import adminReducer from "@/components/classNotes/admin/ducks/slice"
import userReducer from "@/components/classNotes/ducks/slice"
import { combineReducers } from "@reduxjs/toolkit"

const classNoteReducer = combineReducers({
  admin: adminReducer,
  user: userReducer,
})

export default classNoteReducer
